import { uuidv4 } from "lib/helper";
import {
  LOAD_CLOSE_WORK,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // REQUEST
    case LOAD_CLOSE_WORK.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
      };

    // SUCCESS
    case LOAD_CLOSE_WORK.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        totalRows: action.payload.data.total_rows,
        loading: false,
        loadId: uuidv4(),
      };

    // FAILURE
    case LOAD_CLOSE_WORK.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
      };

    default:
      return state;
  }
};
